export function getEntityByName(entity, name) {
  return (Object.values(entity).find(x => x.name === name))
}